module.exports = __webpack_public_path__ + "static/logo-black-small-0bd4f1c1b081d3689d591c08e0790e61.svg";